














import {Vue, Component, Prop} from 'vue-property-decorator';
@Component({
    components: {
    },
})
export default class PostPurchaseScreen extends Vue {
    @Prop({default: ''})
    public title!: string;
    @Prop({default: ''})
    public body!: string;

    public redirectTimer = 10;
    public redirectInterval = null;
    public mounted(){
        this.redirectInterval = setInterval(()=>{
            this.redirectTimer--;
            if(this.redirectTimer === 0){
                this.redirect();
            }
        }, 1000)
    }
    public redirect(){
        clearInterval(this.redirectInterval);
        this.$router.replace('/');
    }
}
